import * as Actions from './actions'
import initialState from '../store/initialState'

export const ShowReducer = (state = initialState.show, action: any) => {
    switch (action.type) {
        case Actions.SET_SHOW_VALUE:
            return {
                ...state,
                ...action.payload
            }
        default:
            return state;
    }
}